import React from "react";
import styles from "./CenteredContent.module.css";

const CenteredContent = ({ title, paragraph, doubleWidth }) => {
  return (
    <div
      className={
        doubleWidth ? styles.centeredContentWidth : styles.centeredContent
      }
    >
      <h1 className={styles.header}>{title}</h1>
      <p className={styles.paragraph}>{paragraph}</p>
    </div>
  );
};

export default CenteredContent;
